import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Transport } from 'src/app/core/_models/transport';
import { FamilyCodes } from 'src/app/core/_enums/family.code';
import { Energie } from 'src/app/core/_models/energie';
@Component({
  selector: 'app-dialog-edit-composition',
  templateUrl: './dialog-edit-composition.component.html',
  styleUrls: ['./dialog-edit-composition.component.scss']
})
export class DialogEditCompositionComponent implements OnInit {
  FamilyCodes = FamilyCodes;
  transportFamilyCode?: string;
  displayForComplexProduct: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<DialogEditCompositionComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    this.transportFamilyCode = this.data.transports.find((t: { resourceId: any }) => t.resourceId == this.data.produits.transportId)?.familyCode;

    if (this.data.displayForComplexProduct != null) {
      this.displayForComplexProduct = this.data.displayForComplexProduct;
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  selectChange(value: string) {
    let t: Transport = this.data?.transports?.find((t: Transport) => t.resourceId == value);
    if (t) {
      this.transportFamilyCode = t?.familyCode;
      this.data.produits.transportId = t?.resourceId;
      this.data.produits.transportName = t?.displayName;
      if (t?.familyCode != FamilyCodes.RoadTransportCode) {
        this.data.produits.energyId = null;
        this.data.produits.energyName = null;
      } else {
        if (!this.data.produits.energyId) {
          const dieselEnergy = this.data?.energies?.find((e: Energie) => e.code === FamilyCodes.DefaultDieselEnergy) ?? this.data?.energies?.find((e: Energie) => e.code === FamilyCodes.DefaultDieselEnergyIntl);
          if (dieselEnergy) {
            this.data.produits.energyId = dieselEnergy.resourceId;
            this.data.produits.energyName = dieselEnergy.displayName;
          }
        }
      }
    } else {
      this.data.produits.transportId = null;
      this.data.produits.transportName = null;
    }
  }

  selectEnergieChange(value: string) {
    let e: Energie = this.data?.energies?.find((e: Energie) => e.resourceId == value);
    if (e && this.transportFamilyCode == FamilyCodes.RoadTransportCode) {
      this.data.produits.energyId = e?.resourceId;
      this.data.produits.energyName = e?.displayName;
    } else {
      this.data.produits.energyId = null;
      this.data.produits.energyName = null;
    }
  }
}
